export default __webpack_public_path__ + "static/media/in_progress_tab.192559fc.svg";